import React from 'react'

export const HomePage = () => {
  return (
    <div>This is homepage</div>
  )
}
